import Image from "next/image";

import { Media } from "../../types/media";
import { isVideo } from "../../core/media.core";

interface MediaListProps {
  mediaList: Media[];
  ids: string[];
  setSelected: (id: string, isSelected: boolean) => void;
}

export default function MediaList(props: MediaListProps) {
  if (!props.mediaList) return null;

  return (
    <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(8rem,_1fr))] justify-items-between">
      {props.mediaList.map((media) => (
        <SelectableMedia
          key={media.filename}
          media={media}
          isSelected={props.ids.find((mediaId) => mediaId === media.id) !== undefined}
          setIsSelected={(isSelected) => {
            props.setSelected(media.id, isSelected);
          }}
        />
      ))}
    </div>
  );
}

interface SelectableMediaProps {
  media: Media;
  isSelected: boolean;
  setIsSelected: (isSelected: boolean) => void;
}

function SelectableMedia(props: SelectableMediaProps) {
  return (
    <section className="media-selector-item">
      {isVideo(props.media) && (
        <video
          className={props.isSelected ? "border-4 border-green-500" : ""}
          src={props.media.url}
          width={200}
          height={200}
          onClick={() => {
            props.setIsSelected(!props.isSelected);
          }}
        />
      )}
      {!isVideo(props.media) && (
        <Image
          unoptimized
          className={props.isSelected ? "border-4 border-green-500" : ""}
          onClick={() => {
            props.setIsSelected(!props.isSelected);
          }}
          src={props.media.thumbnailUrl}
          width={200}
          height={200}
          alt={props.media.filename}
        />
      )}
      <p className="text-xs truncate">{props.media.originalFilename}</p>
    </section>
  );
}
